import { Search } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
}

export function SearchBar({ value, onChange, id = 'search' }: SearchBarProps) {
  return (
    <div className="relative">
      <label htmlFor={id} className="sr-only">Search products</label>
      <input
        id={id}
        type="search"
        placeholder="Search products..."
        value={value}
        onChange={onChange}
        className="w-64 pl-10 pr-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        aria-label="Search products"
      />
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" aria-hidden="true" />
    </div>
  );
}
